<template xmlns="http://www.w3.org/1999/html">
  <div class="animated fadeIn">
    <div class="form-group row">
      <label class="col-md-3 form-control-label">Recruitment date</label>
      <div class="col-md-9">
        <datepicker placeholder="yyyy-mm-dd" input-class="user-vacation-days-date-picker" v-model="activeUsers[employeeId].recruitment_date" format="yyyy-MM-dd"></datepicker>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 form-control-label">Start balance <small>(on 01.01.2019)</small></label>
      <div class="col-md-9">
        <input type="number" class="form-control" :disabled="checkDateOfRecruitment" v-model="activeUsers[employeeId].start_vacation_balance">
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 form-control-label">Balance</label>
      <div class="col-md-9">
        <input class="form-control" type="number" min="0" step="0.01" disabled v-model="activeUsers[employeeId].vacation_balance"/>
      </div>
    </div>
    <div class="form-group row float-right">
      <div class="col-md-3">
        <button class="btn btn-primary" @click="saveVacationDays">Save vacation balance</button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import VueNotifications from 'vue-notifications';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  name: 'UserVacationBalance',
  props: ['employeeId'],
  components: {
    Datepicker

  },
  data: function () {
    return {

    };
  },
  computed: {
    ...mapGetters('JiraUsers', ['activeUsers', 'jiraUserVacationUpdateNotification']),
    checkDateOfRecruitment() {
      if (moment(this.activeUsers[this.employeeId].recruitment_date).format('YYYY-MM-DD') > '2019-01-01') {
        return true;
      }
      return false;
    },
  },
  watch: {
    jiraUserVacationUpdateNotification: {
      handler: function (val) {
        if (this.jiraUserVacationUpdateNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Jira user vacation update status', message: this.jiraUserVacationUpdateNotification.message });
        }
        if (this.jiraUserVacationUpdateNotification.status == 'error') {
          for (const i in this.jiraUserVacationUpdateNotification.message) {
            this.showErrorMsg({
              title: 'Jira user vacation update status',
              message: this.jiraUserVacationUpdateNotification.message[i]
            });
          }
        }
        this.jiraUserVacationUpdateNotification.status = 'loading';
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('JiraUsers', ['SAVE_VACATION_BALANCE']),
    saveVacationDays() {
      if (!this.activeUsers[this.employeeId].start_vacation_balance) {
        this.activeUsers[this.employeeId].start_vacation_balance = 0;
      }
      this.SAVE_VACATION_BALANCE({ startBalance: this.activeUsers[this.employeeId].start_vacation_balance, dateOfRecruitment: moment(this.activeUsers[this.employeeId].recruitment_date).format('YYYY-MM-DD'), userId: this.employeeId });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {

  },
};

</script>

<style scoped>

</style>
<style>
  .user-vacation-days-date-picker {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #607d8b;
    padding: 0.5rem 0.75rem;
  }
</style>
